import { BreadcrumbItem, Breadcrumbs, Pagination } from "@nextui-org/react";
import { AxiosPublic, BaseURL } from "../config/axios";
import paginationHelper from "../helper/paginationHelper";
import Page404 from './404'
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const Search = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const page = searchParams.get('page') || 1;
    const text = searchParams.get('text') || '';

    const [artists, setArtists] = useState([])
    const [categories, setcategories] = useState([])
    const [paintings, setPaintings] = useState([])

    const pagination = useRef({})
    let pages = Math.ceil(pagination.current.total / pagination.current.per_page)

    useEffect(() => {
        if (text.trim().length < 3)
            alert('حداقل طول متن جستجو باید 3 حرف باشد')
        else {
            const get = async () => {
                await AxiosPublic.get(`search?query=${text}&page=${page}`)
                    .then(({ data }) => {
                        setArtists(data ? data.data.artists : [])
                        setcategories(data ? data.data.categories : [])
                        setPaintings(data ? data.data.paintings.data : [])
                        pagination.current = data ? { total: data.data.paintings.total, per_page: data.data.paintings.per_page } : { total: 1, per_page: 1 }
                    })
                    .catch(err => {
                        alert(err.response?.data.mssage || 'پیدا نشد')
                    })
            }
            get()

        }
    }, [text, page])
    const handlePage = (page) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page);
        navigate(`?${newParams.toString()}`, { replace: true })
    }

    return (
        <>
            <title>جستجو: {text}</title>
            {text?.trim()
                ? <div className="my-8" dir="rtl">
                    <div className="container">
                        <Breadcrumbs separator='/' className="pr-6 mb-6" itemClasses={{ separator: "px-2" }}>
                            <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
                            <BreadcrumbItem>جستجو</BreadcrumbItem>
                        </Breadcrumbs>
                        <div className="bg-gray-200 rounded p-4 min-h-[500px]">
                            <h1 className="text-4xl font-semibold my-4 text-primary">نتیجه جستجو برای '{text}'</h1>
                            <div className="flex flex-col gap-8">
                                {page == 1 &&
                                    <>
                                        {!!artists.length && <div className="flex flex-col gap-3">
                                            <div className="border-b border-black mb-1">{artists.length} هنرمند پیدا شد</div>
                                            <div className="flex flex-wrap items-center gap-2">
                                                {artists.map(s => {
                                                    return (
                                                        <Link key={s.id}
                                                            to={`/artists/${s.slug}`}
                                                            className="bg-primary px-2 py-1 italic text-sm rounded-md text-white hover:opacity-80">
                                                            {s.title} | {s.title_persian}
                                                        </Link>
                                                    )
                                                })}
                                            </div>
                                        </div>}
                                        {!!categories.length && <div className="flex flex-col gap-3">
                                            <div className="border-b border-black mb-1">{categories.length} دسته بندی پیدا شد</div>
                                            <div className="flex flex-wrap items-center gap-2">
                                                {categories.map(s => {
                                                    return (
                                                        <Link key={s.id}
                                                            to={`/categories/${s.slug}`}
                                                            className="bg-primary px-2 py-1 italic text-sm rounded-md text-white hover:opacity-80">
                                                            {s.title}
                                                        </Link>
                                                    )
                                                })}
                                            </div>
                                        </div>}
                                    </>
                                }
                                <div className="flex flex-col gap-3">
                                    <div className="border-b border-black mb-1">{pagination.current.total} اثر هنری پیدا شد</div>
                                    {!!paintings.length && <div className="flex flex-col">
                                        <div className="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 items-stretch gap-3">
                                            {paintings.map(s => {
                                                return (
                                                    <Link to={`/product/${s.slug}`} className="bg-[#f6f6f6] flex flex-col items-center overflow-hidden rounded-lg" key={s.id}>
                                                        <div className="grow w-full border-b">
                                                            <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                                                                <img
                                                                    className="object-contain w-full h-full max-h-[250px]"
                                                                    src={BaseURL + s.images[0]?.path} title={s.title}
                                                                    alt={s.title} width={100} height={100}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col items-center p-2 w-full">
                                                            <h4 className="w-full  font-bold text-center line-clamp-1">
                                                                {s.title}
                                                            </h4>
                                                            <h2 className="w-full text-sm font-bold text-center line-clamp-1 border-b pb-1">
                                                                {s.title_persian}
                                                            </h2>
                                                            <div className="w-full py-2 text-center text-sm border-b">
                                                                {s.artist?.title} | {s.category?.title}
                                                            </div>
                                                            {!!s.year && <div className="w-full py-2 centerOfParent gap-1 text-xs border-b">{s.year}</div>}
                                                            <button
                                                                className="bg-primary px-4 py-2 mt-2 rounded-md text-white hover:opacity-80">
                                                                مشاهده
                                                            </button>
                                                        </div>
                                                    </Link>
                                                )
                                            })}
                                        </div>
                                        <div dir="auto" className="centerOfParent mt-4">
                                            {page && !!paintings.length && pages > 1 &&
                                                <Pagination size='sm'
                                                    total={Math.ceil(pages)}
                                                    color="primary"
                                                    page={Number(page)}
                                                    onChange={(e) => { handlePage(e); paginationHelper() }}
                                                    showControls
                                                />}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                : <Page404 />}
        </>
    );
};

export default Search;